var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOgn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.85 2C11.998 2 9.01 3.3 6.886 5.903 4.763 8.507 3.701 11.873 3.702 16c0 2.782.483 5.218 1.448 7.308l5.779-6.024c-.021-.41-.031-.839-.031-1.284-.002-.973.063-1.893.194-2.76.13-.869.355-1.776.673-2.722.318-.946.832-1.695 1.542-2.248.709-.552 1.57-.828 2.584-.828 1.83 0 3.148.891 3.956 2.672l-6.791 7.076.01.01-7.182 7.486c.302.492.636.962 1 1.41C9.013 28.697 12 29.998 15.852 30c3.852 0 6.84-1.301 8.964-3.905C26.937 23.492 28 20.127 28 16c0-2.305-.33-4.372-.993-6.201l-6.205 6.467c-.01.875-.075 1.706-.194 2.494a15.77 15.77 0 0 1-.673 2.722c-.318.946-.832 1.695-1.542 2.248-.71.552-1.572.828-2.586.828-1.455 0-2.587-.565-3.396-1.693l6.779-7.062h-.002l7.183-7.488a12.99 12.99 0 0 0-1.557-2.412C22.688 3.301 19.7 2 15.85 2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOgn);
export default __webpack_public_path__ + "static/media/OGN.23ee9524ae2c2958f111aa0de783d1f7.svg";
export { ForwardRef as ReactComponent };